import React from "react";
import { ApplicantsParent } from "../components/applicants/Applicants";

const Applicants = () => {
  return <ApplicantsParent />;
};

export default Applicants;
